import { render, staticRenderFns } from "./ResetPassPage.vue?vue&type=template&id=bbc50338&scoped=true"
import script from "./ResetPassPage.vue?vue&type=script&lang=ts"
export * from "./ResetPassPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc50338",
  null
  
)

export default component.exports